import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { vw, tabletUp } from '../../../shared/lib/responsive';

const handwritingChar = keyframes`
  to {
    opacity: 1;
    transform: translateY(0) rotate(0deg);
  }
`;

export const Root = styled.span``;

export const Char = styled.span<{
  $pending?: boolean;
  $playing?: boolean;
  $tilt?: 0 | 1 | 2;
}>`
  display: inline-block;
  opacity: 1;
  transform: translateY(0) rotate(0deg);

  ${(p) =>
    p.$pending &&
    css`
      opacity: 0;

      @media (prefers-reduced-motion: reduce) {
        opacity: 1;
      }
    `}

  ${(p) =>
    p.$playing &&
    css`
      opacity: 0;
      transform: translateY(${vw(8)}) rotate(var(--char-tilt, 0deg));

      ${tabletUp} {
        transform: translateY(8px) rotate(var(--char-tilt, 0deg));
      }

      animation: ${handwritingChar} 0.38s cubic-bezier(0.22, 1, 0.36, 1) forwards;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
        opacity: 1;
        transform: none;
      }
    `}

  ${(p) =>
    p.$tilt === 0 &&
    css`
      --char-tilt: -2.5deg;
    `}

  ${(p) =>
    p.$tilt === 1 &&
    css`
      --char-tilt: 1.5deg;
    `}

  ${(p) =>
    p.$tilt === 2 &&
    css`
      --char-tilt: -1deg;
    `}
`;
